// extracted by mini-css-extract-plugin
module.exports = {"title":"TopArtists_title__oZUUV","artist":"TopArtists_artist__3e_m5"};